module.exports = __webpack_public_path__ + "static/media/Help.bb697970.svg";